import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { CookieService } from 'ngx-cookie-service';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreModule } from './core/core.module';
import { LayoutComponent } from './pages/layout/layout.component';
import { DatePipe, CommonModule } from '@angular/common';
import { SetupPasswordComponent } from './pages/setup-password/setup-password.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from './shared/shared.module';

import { ReadyForTabletComponent } from './pages/ready-for-tablet/ready-for-tablet.component';
import { MailInProcessComponent } from './pages/mail-in-process/mail-in-process.component';
import { WaitlistOtherComponent } from './pages/waitlist-other/waitlist-other.component';
import { WaitlistRidesComponent } from './pages/waitlist-rides/waitlist-rides.component';
import { WaitlistDemandComponent } from './pages/waitlist-demand/waitlist-demand.component';
import { CompleteComponent } from './pages/complete/complete.component';
import { DoNotContactComponent } from './pages/do-not-contact/do-not-contact.component';
import { UserVerificationComponent } from './pages/signup/user-verification/user-verification.component';
import { MailingIssueComponent } from './pages/mailing-issue/mailing-issue.component';
import { ReapplyComponent } from './pages/reapply/reapply.component';
import { DriverInitiativeComponent } from './pages/driver-initiative/driver-initiative-response.component';
import { DriverAppRedirectComponent } from './pages/driver-app-redirect/driver-app-redirect.component';
import { DriverTIAResponseComponent } from './pages/driver-tia/driver-tia-response.component';
import { NotInterestedComponent } from './pages/not-interested/not-interested.component';
import { UnsubscribeComponent } from './pages/unsubscribe/unsubscribe.component';
import { AuthorizeComponent } from './pages/uber/authorize/authorize.component';
import { MaintenanceModeComponent } from './pages/maintenance-mode/maintenance-mode.component';
import { UberConnectRequiredComponent } from './pages/uber-connect-required/uber-connect-required.component';
import {ImageCropperModule} from "ngx-image-cropper";
import { GlobalErrorHandler } from './app-error-handler';
import { LeaderboardComponent } from './pages/leaderboard/leaderboard.component';
import { OrderTrackingComponent } from './pages/order-tracking/order-tracking.component';
import { MatListModule } from '@angular/material/list';
import { MatTableModule } from '@angular/material/table';
import { SetPhoneComponent } from './pages/set-phone/set-phone.component';


@NgModule({
    declarations: [
        AppComponent,
        LayoutComponent,
        SetupPasswordComponent,
        CompleteComponent,
        ReadyForTabletComponent,
        MailInProcessComponent,
        WaitlistOtherComponent,
        WaitlistRidesComponent,
        WaitlistDemandComponent,
        DoNotContactComponent,
        UserVerificationComponent,
        MailingIssueComponent,
        ReapplyComponent,
        DriverInitiativeComponent,
        DriverAppRedirectComponent,
        DriverTIAResponseComponent,
        NotInterestedComponent,
        UnsubscribeComponent,
        AuthorizeComponent,
        MaintenanceModeComponent,
        UberConnectRequiredComponent,
        LeaderboardComponent,
        SetPhoneComponent,
        OrderTrackingComponent,
    ],
    imports: [
        BrowserModule,
        CommonModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        MatSidenavModule,
        MatIconModule,
        MatButtonModule,
        MatListModule,
        MatTableModule,
        CoreModule,
        FormsModule,
        ReactiveFormsModule,
        ClipboardModule,
        SharedModule,
        ImageCropperModule,
    ],
    providers: [{ provide: ErrorHandler, useClass: GlobalErrorHandler }, DatePipe, CookieService],
    bootstrap: [AppComponent],
})
export class AppModule {}
